import { Icon, IconButton } from '@atom/mui';
import colors from '@atom/styles/colors';
import { WorkOrderTypeOption } from '@atom/types/work';

import classes from './workTemplateTypeOption.module.css';

interface Props {
  selected?: boolean;
  option: WorkOrderTypeOption;
  onDropdownClick?: () => void;
  dropdown?: boolean;
}

const WorkTemplateTypeOption = ({
  option,
  dropdown = false,
  selected = false,
  onDropdownClick = () => {},
}: Props) => {
  const titleStyles = {
    color: selected ? colors.brand.blue : colors.neutral.dim,
  };

  return (
    <div className={classes.typeOptionContainer}>
      <div className={classes.typeOptionContent}>
        <img src={option.icon} />
        <div className={classes.typeOptionText}>
          <div style={titleStyles}>{option.title}</div>
          <div className={classes.typeOptionSubtext}>{option.subtext}</div>
        </div>
      </div>
      {dropdown && (
        <IconButton onClick={onDropdownClick}>
          <Icon>arrow_drop_down_icon</Icon>
        </IconButton>
      )}
    </div>
  );
};

export default WorkTemplateTypeOption;
